module.exports = __webpack_public_path__ + "img/Jiangsu-speed.76a863c1.png";